import React, { useEffect, useRef } from "react";
import qtnMarkPng from'../../asset/qtn-mark.png';
import { Tooltip } from 'react-tooltip'

export default function MyTooltip(prop) {
	let msg = prop.msg
	return (
			<div>				
				{
					<Tooltip anchorSelect=".my-anchor-element" style={{textAlign:"left", zIndex:1}} place="right-start">
						<div dangerouslySetInnerHTML={{ __html: msg }} />
					</Tooltip>
				}
				<img className="my-anchor-element" style={{width:"20px", height:"20px"}} src={qtnMarkPng} />
			</div>)
}

